module.exports = __webpack_public_path__ + "img/hongkong_000.d239656c.png";